// Copyright 2021 Pangea Cyber Corporation
// Author: Pangea Cyber Corporation

import { graphql, useStaticQuery } from "gatsby";
import { useSbdSeriesDataById } from "./sbdSeriesDataById";
import { set } from "lodash";

export const useSbdArticlesData = () => {
  const seriesById: any = useSbdSeriesDataById();

  const { allIndexYaml } = useStaticQuery(graphql`
    {
      allIndexYaml(
        filter: {
          path: { regex: "/securebydesign//" }
          seriesKey: { ne: null }
        }
        sort: { order: ASC }
      ) {
        group(field: { seriesKey: SELECT }) {
          seriesKey: fieldValue
          totalCount
          nodes {
            seriesKey
            additionalSeriesKeys {
              key
              order
            }
            title
            blurb
            order
            path # used as the key
            authors
          }
        }
      }
    }
  `);

  // The articles to cross-list
  const crossListArticles: {
    [seriesKey: string]: {
      [articleKey: string]: any;
    };
  } = {};

  // Track which has been listed in what series so we don't duplicate them
  const crossListedArticles: {
    [seriesKey: string]: {
      [articleKey: string]: any;
    };
  } = {};

  for (const group of allIndexYaml.group) {
    for (const node of group?.nodes ?? []) {
      for (const additionalSeries of node?.additionalSeriesKeys ?? []) {
        const seriesKey = additionalSeries.key;

        set(crossListArticles, `${seriesKey}.${node.path}`, {
          ...node,
          order: additionalSeries?.order ?? node.order,
        });
      }
    }
  }

  return allIndexYaml.group.map((_group: any) => {
    const group = { ..._group };
    for (const [crossListArticleKey, crossListArticle] of Object.entries(
      crossListArticles?.[group.seriesKey] ?? {},
    )) {
      if (!crossListedArticles?.[group.seriesKey]?.[crossListArticleKey]) {
        group.nodes = [...group.nodes, crossListArticle];

        set(
          crossListedArticles,
          `${group.seriesKey}.${crossListArticleKey}`,
          true,
        );
      }
    }

    group.totalCount = group.nodes.length;

    return {
      ...group,
      ...seriesById[group.seriesKey],
    };
  });
};
